/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AffiliatedGroupDetail } from '../models/affiliated-group-detail';
import { AffiliatedGroupListItem } from '../models/affiliated-group-list-item';
import { BooleanResponse } from '../models/boolean-response';
import { createAffiliatedGroup } from '../fn/affiliated-group-management/create-affiliated-group';
import { CreateAffiliatedGroup$Params } from '../fn/affiliated-group-management/create-affiliated-group';
import { deleteAffiliatedGroup } from '../fn/affiliated-group-management/delete-affiliated-group';
import { DeleteAffiliatedGroup$Params } from '../fn/affiliated-group-management/delete-affiliated-group';
import { getAffiliatedGroup } from '../fn/affiliated-group-management/get-affiliated-group';
import { GetAffiliatedGroup$Params } from '../fn/affiliated-group-management/get-affiliated-group';
import { listAffiliatedGroups } from '../fn/affiliated-group-management/list-affiliated-groups';
import { ListAffiliatedGroups$Params } from '../fn/affiliated-group-management/list-affiliated-groups';
import { updateAffiliatedGroup } from '../fn/affiliated-group-management/update-affiliated-group';
import { UpdateAffiliatedGroup$Params } from '../fn/affiliated-group-management/update-affiliated-group';

@Injectable({ providedIn: 'root' })
export class AffiliatedGroupManagementService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listAffiliatedGroups()` */
  static readonly ListAffiliatedGroupsPath = '/rest/admin/affiliated-group';

  /**
   * List all affiliated groups (consolidations) with their parent profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAffiliatedGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAffiliatedGroups$Response(params?: ListAffiliatedGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AffiliatedGroupListItem>>> {
    return listAffiliatedGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * List all affiliated groups (consolidations) with their parent profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAffiliatedGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAffiliatedGroups(params?: ListAffiliatedGroups$Params, context?: HttpContext): Observable<Array<AffiliatedGroupListItem>> {
    return this.listAffiliatedGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AffiliatedGroupListItem>>): Array<AffiliatedGroupListItem> => r.body)
    );
  }

  /** Path part for operation `createAffiliatedGroup()` */
  static readonly CreateAffiliatedGroupPath = '/rest/admin/affiliated-group';

  /**
   * Create new affiliated group (consolidation) with its members and parent.
   *
   * A profile already in another group is never moved, it has to be removed from its group first.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAffiliatedGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAffiliatedGroup$Response(params: CreateAffiliatedGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<AffiliatedGroupDetail>> {
    return createAffiliatedGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Create new affiliated group (consolidation) with its members and parent.
   *
   * A profile already in another group is never moved, it has to be removed from its group first.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAffiliatedGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAffiliatedGroup(params: CreateAffiliatedGroup$Params, context?: HttpContext): Observable<AffiliatedGroupDetail> {
    return this.createAffiliatedGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<AffiliatedGroupDetail>): AffiliatedGroupDetail => r.body)
    );
  }

  /** Path part for operation `getAffiliatedGroup()` */
  static readonly GetAffiliatedGroupPath = '/rest/admin/affiliated-group/{id}';

  /**
   * Get affiliated group (consolidation) with all its members.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAffiliatedGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAffiliatedGroup$Response(params: GetAffiliatedGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<AffiliatedGroupDetail>> {
    return getAffiliatedGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Get affiliated group (consolidation) with all its members.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAffiliatedGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAffiliatedGroup(params: GetAffiliatedGroup$Params, context?: HttpContext): Observable<AffiliatedGroupDetail> {
    return this.getAffiliatedGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<AffiliatedGroupDetail>): AffiliatedGroupDetail => r.body)
    );
  }

  /** Path part for operation `updateAffiliatedGroup()` */
  static readonly UpdateAffiliatedGroupPath = '/rest/admin/affiliated-group/{id}';

  /**
   * Replace whole affiliated group (title, members, parent) in one transaction.
   *
   * Members not in profileIds are removed from the group. A profile already in another group is never moved, it has to be removed from its group first.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAffiliatedGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAffiliatedGroup$Response(params: UpdateAffiliatedGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<AffiliatedGroupDetail>> {
    return updateAffiliatedGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Replace whole affiliated group (title, members, parent) in one transaction.
   *
   * Members not in profileIds are removed from the group. A profile already in another group is never moved, it has to be removed from its group first.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAffiliatedGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAffiliatedGroup(params: UpdateAffiliatedGroup$Params, context?: HttpContext): Observable<AffiliatedGroupDetail> {
    return this.updateAffiliatedGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<AffiliatedGroupDetail>): AffiliatedGroupDetail => r.body)
    );
  }

  /** Path part for operation `deleteAffiliatedGroup()` */
  static readonly DeleteAffiliatedGroupPath = '/rest/admin/affiliated-group/{id}';

  /**
   * Delete affiliated group, all its members are removed from it (profiles are not deleted).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAffiliatedGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAffiliatedGroup$Response(params: DeleteAffiliatedGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
    return deleteAffiliatedGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete affiliated group, all its members are removed from it (profiles are not deleted).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAffiliatedGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAffiliatedGroup(params: DeleteAffiliatedGroup$Params, context?: HttpContext): Observable<BooleanResponse> {
    return this.deleteAffiliatedGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<BooleanResponse>): BooleanResponse => r.body)
    );
  }

}
